import {inject, Injectable} from '@angular/core';
import {UserInfo} from './model/UserInfo';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {OkDialogComponent} from './ok-dialog/ok-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class AisCommonService
{
    private http = inject(HttpClient);
    private matDialog = inject(MatDialog);

    private userInfo: UserInfo = null;

    public userInfoSubject = new Subject<UserInfo>();

    fetchUserInfo() {
        if (this.userInfo !== null) {
            this.userInfoSubject.next(this.userInfo);
        }
        this.http
            .get<UserInfo>('/ais/rest/portal/users/info')
            .subscribe((data) => {
                this.userInfo = data;
                this.userInfoSubject.next(this.userInfo);
            });
    }

    showOkDialog(message: string) {
        this.matDialog.open(OkDialogComponent, {
            data: {message}
        });
    }

}
